import {Link} from "@inertiajs/react";
import {Activity, CreditCard, FileText, MapPin, Tag, Users, History} from "lucide-react";


const Index = () => {
    return (
        <div className="p-8">
            <div className="mb-8">
                <h2 className="text-3xl font-bold text-foreground">System Administration</h2>
                <p className="text-muted-foreground">Manage agents, tax types, and system configuration</p>
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                <Link href="/admin/agents">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-primary/10 p-3">
                                <Users className="h-6 w-6 text-primary" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Agent Management</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Manage collection agents, routes, and performance</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">12</span>
                                        <span className="ml-1 text-muted-foreground">Active</span>
                                    </div>
                                    <div>
                                        <span className="text-2xl font-bold text-muted-foreground">3</span>
                                        <span className="ml-1 text-muted-foreground">Inactive</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/admin/tax-types">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-accent/10 p-3">
                                <FileText className="h-6 w-6 text-accent" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Tax Type Management</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Configure tax types, rates, and collection rules</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">8</span>
                                        <span className="ml-1 text-muted-foreground">Tax Types</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/system/areas">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-info/10 p-3">
                                <MapPin className="h-6 w-6 text-info" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Area Management</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Manage collection areas and assign to agents</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">4</span>
                                        <span className="ml-1 text-muted-foreground">Areas</span>
                                    </div>
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">824</span>
                                        <span className="ml-1 text-muted-foreground">Taxpayers</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/system/categories">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-success/10 p-3">
                                <Tag className="h-6 w-6 text-success" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Category Management</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Manage taxpayer categories and classifications</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">5</span>
                                        <span className="ml-1 text-muted-foreground">Categories</span>
                                    </div>
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">684</span>
                                        <span className="ml-1 text-muted-foreground">Taxpayers</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/system/devices">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-warning/10 p-3">
                                <CreditCard className="h-6 w-6 text-warning" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">POS Management</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Monitor POS devices and transactions</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">3</span>
                                        <span className="ml-1 text-muted-foreground">Active</span>
                                    </div>
                                    <div>
                                        <span className="text-2xl font-bold text-muted-foreground">1</span>
                                        <span className="ml-1 text-muted-foreground">Inactive</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/system/collect_sessions">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-info/10 p-3">
                                <Activity className="h-6 w-6 text-info" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Tax Collection</h3>
                                <p className="mt-1 text-sm text-muted-foreground">Monitor active collection sessions and devices</p>
                                <div className="mt-4 flex items-center gap-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">4</span>
                                        <span className="ml-1 text-muted-foreground">Sessions</span>
                                    </div>
                                    <div>
                                        <span className="text-2xl font-bold text-success">1.97M FCFA</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>

                <Link href="/admin/audit">
                    <div className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-secondary/50">
                        <div className="flex items-start gap-4">
                            <div className="rounded-lg bg-success/10 p-3">
                                <History className="h-6 w-6 text-success" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-foreground">Audit Trail</h3>
                                <p className="mt-1 text-sm text-muted-foreground">View system changes and administrative actions</p>
                                <div className="mt-4 text-sm">
                                    <div>
                                        <span className="text-2xl font-bold text-foreground">247</span>
                                        <span className="ml-1 text-muted-foreground">Events Today</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>

            <div className="mt-6 rounded-lg border border-border bg-card p-6">
                <h3 className="mb-4 text-lg font-semibold text-foreground">System Information</h3>
                <div className="grid gap-4 md:grid-cols-4">
                    <div className="rounded-lg border border-border bg-secondary p-4">
                        <p className="text-sm text-muted-foreground">Database Status</p>
                        <p className="mt-2 flex items-center gap-2 text-lg font-semibold text-success">
                            <span className="h-2 w-2 rounded-full bg-success"></span>
                            Connected
                        </p>
                    </div>
                    <div className="rounded-lg border border-border bg-secondary p-4">
                        <p className="text-sm text-muted-foreground">Active Agents</p>
                        <p className="mt-2 text-lg font-semibold text-foreground">12 / 15</p>
                    </div>
                    <div className="rounded-lg border border-border bg-secondary p-4">
                        <p className="text-sm text-muted-foreground">Last Backup</p>
                        <p className="mt-2 font-mono text-sm text-foreground">2024-01-15 12:00</p>
                    </div>
                    <div className="rounded-lg border border-border bg-secondary p-4">
                        <p className="text-sm text-muted-foreground">System Version</p>
                        <p className="mt-2 font-mono text-sm text-foreground">v2.4.1</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;